/**
 * Cookie Consent
 */
UIkit.util.on('[data-cookie-consent]', 'hidden', () => {
  $.post('/wp-json/signal/v1/cookie-consent');
});



// WEBPACK FOOTER //
// ./resources/js/components/cookieConsent.js